
  <!-- <div class="nav-container-1">
    <form [formGroup]="searchForm">
      <div class="row">
        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
          <EIPAutoComplete TextField="dedDescription" ValueField="dedId" WaterMarkText="Discipline"
            formControlName="ctrlDiscipline" setId="ddlDiscipline" ShowTextValueField='N' [dataSource]='discList'
            [defaultValue]="selectedDiscipline" [SingleValueBind]="false" [IsCascading]='true'
            (valueChange)='setSelectedDiscipline($event)'>
          </EIPAutoComplete>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
          <EIPAutoComplete TextField="dedDescription" ValueField="dedId" WaterMarkText="Structure"
            formControlName="ctrlStructure" setId="ddlStructure" ShowTextValueField='N' [dataSource]='structureList'
            [defaultValue]="selectedStructure" [SingleValueBind]="false" [IsCascading]='true'
            (valueChange)='setSelectedStructure($event)'>
          </EIPAutoComplete>
        </div>
      </div>
    </form>
  </div> -->
  <!-- [language]="language"  [toolbar]="toolbar" -->
  <div>
    <ssrs-reportviewer [reportserver]="reportServer" [reporturl]="reportUrl" [showparameters]="showParameters"
      [parameters]="parameters"  [width]="width" [height]="height" >
    </ssrs-reportviewer>
  </div>
